import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { z } from 'zod'

import 'dayjs/locale/vi'
import 'dayjs/locale/th'

import { CHANNEL_ID } from '~/consts'
import i18n from '~/i18n'

dayjs.extend(LocalizedFormat)

export function formatChannelName(channelId: number) {
    const result = z.enum(CHANNEL_ID).safeParse(channelId)
    if (!result.success) {
        return 'Unknown channel'
    }

    const validChannelId = result.data
    switch (validChannelId) {
        case CHANNEL_ID.Lazada:
            return 'Lazada'
        case CHANNEL_ID.LazadaVN:
            return 'Lazada Vietnam'
        case CHANNEL_ID.Shopee:
            return 'Shopee'
        case CHANNEL_ID.Shopify:
            return 'Shopify'
        case CHANNEL_ID.JDCentral:
            return 'JD Central'
        case CHANNEL_ID.WooCommerce:
            return 'WooCommerce'
        case CHANNEL_ID.Facebook:
            return 'Facebook'
        case CHANNEL_ID.TikTok:
            return 'TikTok'
        case CHANNEL_ID.Magneto:
            return 'Magneto'
        case CHANNEL_ID.Line:
            return 'Line'
        default: {
            const _exhaustiveCheck: never = validChannelId
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`Unhandled channel id: ${_exhaustiveCheck}`)
        }
    }
}

export function formatMoney(price: number, currency: string, options?: { locale?: string }) {
    const locale = options?.locale ?? navigator.language

    return Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 2,
    }).format(price)
}

export function formatDate(
    date: string | number | Date,
    options?: {
        format?: string
        locale?: string
    }
) {
    return dayjs(date)
        .locale(options?.locale ?? i18n.language)
        .format(options?.format ?? 'lll')
}
